import React from 'react';
import MonitoringActivities from './MonitoringActivities';
import Comment from './Comment';
import Accordion from '../../Accordion';

const identifications = [
  { name: 'Monitoring Activities', component: MonitoringActivities },
  { name: 'Comments', component: Comment },
];
const Monitoring = () => (
  <div className="w-full mx-auto">
    {identifications.map((identification) => (
      <div key={identification.name} className="rounded-md shadow-md mb-10">
        <Accordion
          title={identification.name}
          content={identification.component}
        />
      </div>
    ))}
  </div>
);
export default Monitoring;
